<template>
    <div class="container">
        <div class="row align-items-start">
            <div class="col-6">
                <div class="row align-items-start">
                    <div class="col-auto">
                        <!-- Icon -->
                        <span class="fs-1">⌚</span>
                    </div>
                    <div class="col">
                        <!-- Title and Description -->
                        <h3 class="mb-1 fw-bold">Client & Deadline Focused</h3>
                        <p class="mb-0 text-secondary">
                            Track client-specific tasks with Task Tally to stay
                            organized and never miss a deadline.
                        </p>
                    </div>
                </div>
            </div>
            <div class="col-6">
                <div class="row align-items-start">
                    <div class="col-auto">
                        <!-- Icon -->
                        <span class="fs-1">💎</span>
                    </div>
                    <div class="col">
                        <!-- Title and Description -->
                        <h3 class="mb-1 fw-bold">Task Prioritization</h3>
                        <p class="mb-0 text-secondary">
                            Task Tally helps prioritize tasks, ensuring you
                            deliver high-quality work on time.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
h3 {
    font-size: 1em;
}
p {
    font-size: 0.8em;
}
</style>
